import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { NavigationService } from '../../shared/services/navigation.service';

@Component({
  selector: 'app-password-change-callback',
  templateUrl: './password-change-callback.component.html',
  styleUrls: ['./password-change-callback.component.scss']
})
export class PasswordChangeCallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private navigation: NavigationService,
              private authService: AuthenticationService,
              private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe((params: Params): void => {
      if (params.success) {
        toastr.success('Your password have been successfully changed');
      } else {
        toastr.error('An error occured while changing your password');
      }

      this.redirectToHome();
    });
  }

  ngOnInit() {
  }

  redirectToHome() {
    if (this.authService.canManageCarriers()) {
      this.navigation.overview().go();
    } else {
      this.navigation.home().go();
    }
  }

}
